import App from "./App";

const env = window._env_?.NODE_ENV;

if (!["local", "develop", "staging", "production", "preprod"].includes(env)) {
  alert(
    `No env found. Did you setup the .env-config.js file correctly? (ENV = ${env})`,
  );
}

const Root = () => {
  return <App />;
};

export default Root;
